// Centralized global state initialization
// Prevents divergence and accidental overwrites when multiple packs are loaded

export const initGlobalState = () => {
  return {
    flashMessages: [],
    aiTaskEvents: []
  }
}